<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 flex justify-between mb-6">
      <span class="text-[#2d82b5] font-semibold">
        IELTS for {{ data.full_name }}
      </span>
      <span class="text-sm">
        {{ $t("common.student_id") }}:
        <span class="font-semibold">{{ data.student_code }}</span>
        <span class="ml-4">
          {{ $t("common.grade") }}:
          <span class="font-semibold">{{ data.grade }}</span>
        </span>
      </span>
    </div>

    <div class="md-layout-item md-size-100 mb-3" v-if="!!data.chartData">
      <chart :data-detail="data"></chart>
    </div>

    <div class="md-layout-item md-size-100 mb-3">
      <p class="font-medium mb-3">
        {{ $t("smi_sri.detail_about_tests") }}
      </p>
      <md-table class="table-pdf-assessment">
        <md-table-row>
          <md-table-cell rowspan="2">
            <span class="w-max inline-block">
              {{ $t("smi_sri.test_name") }}
            </span>
          </md-table-cell>
          <md-table-cell rowspan="2">Overall</md-table-cell>
          <md-table-cell rowspan="2">Test date W</md-table-cell>
          <md-table-cell rowspan="2">Listening</md-table-cell>
          <md-table-cell rowspan="2">Reading</md-table-cell>
          <md-table-cell colspan="3" class="text-center">
            Writing
          </md-table-cell>
          <md-table-cell colspan="6" class="text-center">
            Speaking
          </md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>Task 1</md-table-cell>
          <md-table-cell>Task 2</md-table-cell>
          <md-table-cell>Brand score W</md-table-cell>
          <md-table-cell>Test date S</md-table-cell>
          <md-table-cell>GR</md-table-cell>
          <md-table-cell>LR</md-table-cell>
          <md-table-cell>FC</md-table-cell>
          <md-table-cell>P</md-table-cell>
          <md-table-cell>Brand score S</md-table-cell>
        </md-table-row>
        <md-table-row
          v-for="(row, index) in data.ielts"
          :key="'Detail about tests' + index"
        >
          <md-table-cell class="text-center">
            <span class="w-max inline-block">{{ row.test_name }}</span>
          </md-table-cell>
          <md-table-cell>
            {{ row.overall }}
          </md-table-cell>
          <md-table-cell>
            {{ convertDateFromServer(row.writing.test_date_w, "date") }}
          </md-table-cell>
          <md-table-cell>
            {{ row.writing.listening }}
          </md-table-cell>
          <md-table-cell>
            {{ row.writing.reading }}
          </md-table-cell>
          <md-table-cell>
            {{ row.writing["task 1"] }}
          </md-table-cell>
          <md-table-cell>
            {{ row.writing["task 2"] }}
          </md-table-cell>
          <md-table-cell>
            {{ row.writing.band_score_w }}
          </md-table-cell>
          <md-table-cell>
            {{ convertDateFromServer(row.speaking.test_date_s, "date") }}
          </md-table-cell>
          <md-table-cell>
            {{ row.speaking["GR"] }}
          </md-table-cell>
          <md-table-cell>
            {{ row.speaking["LR"] }}
          </md-table-cell>
          <md-table-cell>
            {{ row.speaking["FC"] }}
          </md-table-cell>
          <md-table-cell>
            {{ row.speaking["P"] }}
          </md-table-cell>
          <md-table-cell>
            {{ row.speaking.band_score_s }}
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>

    <div class="md-layout-item md-size-100 mb-3">
      <p class="font-medium mb-3">
        {{ $t("smi_sri.comment_for_tests") }}
      </p>
      <md-table class="table-pdf-assessment">
        <md-table-row class="text-center">
          <md-table-cell rowspan="2">
            <span class="w-max inline-block">
              {{ $t("smi_sri.test_name") }}
            </span>
          </md-table-cell>
          <md-table-cell colspan="2">
            {{ $t("smi_sri.comment") }}
          </md-table-cell>
        </md-table-row>
        <md-table-row class="text-center">
          <md-table-cell>Speaking</md-table-cell>
          <md-table-cell>Writing</md-table-cell>
        </md-table-row>
        <md-table-row
          v-for="(row, index) in data.ielts"
          :key="'Comment for tests' + index"
        >
          <md-table-cell class="text-center">
            <span class="w-max inline-block">{{ row.test_name }}</span>
          </md-table-cell>
          <md-table-cell>
            {{ row.comment.speaking }}
          </md-table-cell>
          <md-table-cell>
            {{ row.comment.writing }}
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import Chart from "./Chart";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  name: "export-pdf-ielts",
  components: { Chart },
  props: ["data"],
  data() {
    return {
      convertDateFromServer
    };
  }
};
</script>
